// Colour names from https://www.color-blindness.com/color-name-hue/
export default {
  screens: {
    xs: 0,
    sm: 640,
    md: 768,
    lg: 1024,
    xl: 1280,
  },
  other: {
    readable: 700,
    navSize: 180,
  },
  colors: {
    black: "#000",
    text: "#000",
    white: "#fff",
    delta: "#989D92",
    smoke: "#ececec",
    gondola: "#343434",
    picton: "#7D7AA2",
    cerulean: "#5A819E",
    salmon: "#FFC1A7",
    froly: "#F67E7D",
    sand: "#FFE5C4",
    tangerine: "#ffb717",
    cardinal: "#d42128",
    purple: "#6d1e6a",
    yellowGreen: "#8bc53f",
    racingGreen: "#005b34",
    sapphire: "#072647",
    sinbad: "#9DCFC2",
    monteCarlo: "#6CC2BD",
    nero: "#2D2D2D",
    mortar: "#555555",
    glass: "hsla(207, 26%, 34%, 0.8)",
    fade: "rgba(0, 0, 0, 0.1)",
  },
  spacing: {
    none: "0",
    extraEmall: "0.25rem",
    small: "0.5rem",
    medium: "1rem",
    large: "2rem",
    extraLarge: "4rem",
  },
  opacity: {
    0: 0,
    25: 0.25,
    50: 0.5,
    75: 0.75,
    100: 1,
  },
};
